// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"712a9ea3","453":"f0e03184"}[chunkId] + ".chunk.js";
};